export enum TranslatedContactType {
  EMAIL = "Email",
  PHONE_NUMBER = "Telefone",
  WHATSAPP = "Whatsapp"
}
